import { useRef } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { DATA_TYPE } from "../../../utils/enum";
import "./autoSuggest.scss";

const deboounceTime = 500; //ms

const AutoSuggest = ({ item, handleSearch, options, index, onChangeHandler, parentData }) => {
  const ref = useRef();
  const debounceRef = useRef();

  const handleInputChange = (text) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      if (text.length >= 2) {
        handleSearch(text, item, index);
      }
      const value = text ? [{ label: text, value: text, customOption: true }] : [];
      onChangeHandler(value, item, index, parentData);
    }, deboounceTime);
  };

  return (
    <div className="autoSuggest_container">
      <AsyncTypeahead
        ref={ref}
        clearButton
        emptyLabel="No suggestions found"
        promptText={`Type ${item.title}`}
        id="async-example"
        labelKey="label"
        multiple={item?.type === DATA_TYPE.string ? false : true}
        minLength={2}
        delay={deboounceTime}
        maxResults={5}
        useCache={false}
        paginationText="Load More..."
        paginate
        isLoading={item.loading}
        onSearch={() => {
          return;
        }}
        onInputChange={handleInputChange}
        options={options}
        placeholder={item.title}
        onChange={(value) => onChangeHandler(value, item, index, parentData)}
      />
    </div>
  );
};

export default AutoSuggest;
